export default __webpack_public_path__ + "static/4_24-5c5114867dfd80894c23b815e9eadd79.png";